import React from 'react';

/**
 * Wrapped to add unhashed class
 * @see /public/index.html
 */
export const ScrollViewWrapper: React.FC = props => (
  <div className="always-show-scrollbar" {...props} />
);
